<template>
  <v-container>
    <creditor-event-view-component v-if="user && user.profile == 1"></creditor-event-view-component>
    <lawyer-event-view-component v-if="user && user.profile == 4"></lawyer-event-view-component>
  </v-container>
</template>

<script>
import 'moment/locale/pt-br'
import CreditorEventViewComponent from '@/components/creditor/CreditorEventViewComponent.vue'
import LawyerEventViewComponent from '@/components/lawyer/LawyerEventViewComponent.vue'

export default {
  components: {
    'creditor-event-view-component': CreditorEventViewComponent,
    'lawyer-event-view-component': LawyerEventViewComponent,
  },
  data: () => ({
    user: null,
  }),

  created() {
    this.$ga.event({
      eventCategory: 'page',
      eventAction: 'action',
      eventLabel: 'click',
      eventValue: 'user-area'
    })

    this.user = this.$root.user;

    console.log('Event view user', this.user)

  },

}
</script>

<style lang="scss"></style>
